export default __webpack_public_path__ + "static/media/icon-card.86961ab1.png";